// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

// Babel
require('core-js/stable');
require('regenerator-runtime/runtime');

// Modules
const externalUserModule = require('../modules/external-user');
const navigationModule = require('../modules/navigation');
const inputModule = require('../modules/input');


/**
 * Action Handlers
 */

function createActionHandlers() {

	// Handle auth error
	$(document).ready(() => {
		if (inputModule.getParameterByName('result') === 'classlink_error') {
			inputModule.showBlockAlert("We're having trouble signing into your ClassLink account. Please try again.");
		}
	});

	// Handle press action button
	$(document).keypress((e) => {
		if (e.keyCode === 13) {
			$('#user-action-button').click();
		}
	});

	// Handle click on classlink button
	$('#classlink-button').click(() => {
		externalUserModule.handleClassLinkSignUp();
	});

	// Handle click on back button
	$('#back-button').click(() => {
		window.location = `/enroll${window.location.search}`;
	});

	// Handle click on action button
	$('#user-action-button').click(() => {
		externalUserModule.handleUserSignUp();
	});
}


/**
 * Input Handlers
 */

function createInputHandlers() {

	// Handle focus
	$('#firstName, #lastName, #email, #pass, #confirmPass').focus(() => {
		inputModule.removeBlockAlert();
	});

	// Handle first name blur
	$('#firstName').blur(() => {
		inputModule.removeAlert('firstNameLabel', 'Your First Name', true);
	});

	// Handle last name blur
	$('#lastName').blur(() => {
		inputModule.removeAlert('lastNameLabel', 'Your Last Name', true);
	});

	// Handle email blur
	$('#email').blur(() => {
		inputModule.removeAlert('emailLabel', 'Your Email', true);
	});

	// Handle password blur
	$('#pass').blur(() => {
		inputModule.removeAlert('passLabel', 'Create a New Password', true);
	});

	// Handle confirm password blur
	$('#confirmPass').blur(() => {
		inputModule.removeAlert('confirmPassLabel', 'Confirm Your New Password', true);
	});

	// Handle first name key down
	$('#firstName').keydown(() => {
		inputModule.removeAlert('firstNameLabel', 'Your First Name', true);
	});

	// Handle last name key down
	$('#lastName').keydown(() => {
		inputModule.removeAlert('lastNameLabel', 'Your Last Name', true);
	});

	// Handle email key down
	$('#email').keydown(() => {
		inputModule.removeAlert('emailLabel', 'Your Email', true);
	});

	// Handle password key down
	$('#pass').keydown(() => {
		inputModule.removeAlert('passLabel', 'Create a New Password', true);
	});

	// Handle confirm password key down
	$('#confirmPass').keydown(() => {
		inputModule.removeAlert('confirmPassLabel', 'Confirm Your New Password', true);
	});
}


/**
 * Init
 */

// Initialize navigation
navigationModule.initialize();

// Handle SSO routing
externalUserModule.handleSSOPassthrough();
externalUserModule.handleResetOnboarding();

// Create action handlers
createActionHandlers();

// Create input handlers
createInputHandlers();
